import React from "react";
import { Grid } from "@mui/material";
import { Button as MuiButton } from "@mui/material";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { content } from "constants/content";
import { auth } from '../../firebase';
import FacebookLoginButton from "components/FacebookLoginButton";

const buttonStyle = {
  width: "200px",
  height: "48px",
};

const SocialMediaLogin = ({ lang }) => {
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Optionally, you can save additional user data to MySQL here
      navigate("/dashboard");
    } catch (error) {
      console.error("Google sign-in error:", error);
      // Handle errors here
    }
  };

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <MuiButton
          variant="contained"
          color="error"
          onClick={handleGoogleLogin}
          sx={buttonStyle}
        >
          {content[lang]?.buttons?.loginWithGoogle || "Login with Google"}
        </MuiButton>
      </Grid>
      <Grid item>
        <FacebookLoginButton lang={lang} />
      </Grid>
    </Grid>
  );
};

export default SocialMediaLogin;
